import Form from '@admin/components/form'
import TimingToken from './cancel_timing'
import PropTypes from 'prop-types'
import React from 'react'

class Cancel extends React.PureComponent {

  static propTypes = {
    formdata: PropTypes.object,
    props: PropTypes.object,
    onBack: PropTypes.func,
    onCancel: PropTypes.func,
    onChange: PropTypes.func,
    onNext: PropTypes.func,
    onSave: PropTypes.func
  }

  formRef = React.createRef()

  state = {
    config: {}
  }

  _handleBack = this._handleBack.bind(this)
  _handleChange = this._handleChange.bind(this)
  _handleSubmit = this._handleSubmit.bind(this)
  _handleSuccess = this._handleSuccess.bind(this)

  render() {
    return <Form { ...this._getForm() } />
  }

  _getForm() {
    const { config } = this.state
    return {
      ref: this.formRef,
      showHeader: false,
      buttons: [
        { label: 't(Previous)', color: 'blue', basic: true, handler: this._handleBack },
        { label: 't(Finish)', color: 'blue', handler: this._handleSubmit }
      ],
      onChange: this._handleChange,
      onSuccess: this._handleSuccess,
      sections: [
        {
          fields: [
            { 
              label: 't(Timing)',
              name: 'strategy', 
              type: 'radiogroup',
              options: [
                'schedule',
                'now'
              ],
              format: TimingToken,
              defaultValue: 'schedule'
            },
            {
              label: 't(Follow-up Question)',
              instructions: 't(We\'re sorry to see you go. Can you share why you\'re cancelling?)',
              type: 'segment',
              fields: [
                { 
                  name: 'cancellation.reasons', 
                  type: 'checkboxgroup',
                  options: [
                    { value: 'not_selling', text: 't(I\'m not actively selling travel right now)' },
                    { value: 'no_time', text: 't(I didn\'t have time to use the platform)' },
                    { value: 'no_response', text: 't(My clients aren\'t responding to the content)' },
                    { value: 'found_another', text: 't(I found another platform that fits better)' },
                    { value: 'too_expensive', text: 't(It was too expensive)' },
                    { value: 'not_understand', text: 't(I didn\'t understand how to use it)' },
                    { value: 'not_value', text: 't(I didn\'t see the value)' },
                    { value: 'seasonal', text: 't(I only needed it for a short time (seasonal))' },
                    { value: 'other', text: 't(Other (please explain))' }
                  ],
                  required: true
                }, 
                {
                  name: 'cancellation.other',
                  type: 'textarea',
                  placeholder: 't(Want to tell us more? (Optional))',
                  show: config.cancellation?.reasons?.includes('other') === true
                }    
              ]
            }
          ]
        }
      ]
    }
  }

  _handleBack() {
    this.props.onBack()
  }

  _handleChange(config) {
    this.setState({ config })
  }

  _handleSubmit() {
    this.formRef.current.submit()
  }

  _handleSuccess({ cancellation, strategy }) {
    this.props.onSave({
      operation: 'cancel',
      strategy,
      cancellation
    })
  }

}

export default Cancel
